import React, { useState, useEffect } from 'react';

import iconAviso from '../../../resources/img/icon-aviso-modal.svg';
import SideMenu from '../../../Components/SideMenu';
import Header from '../../../Components/Header';
import Redirect from '../../../Components/RedirectScreen';
import Loading from '../../../Components/LoaderScreen';
import Alert from '../../../Components/Alert';
import Modal from '../../../Components/Modal';
import Input from '../../../Components/Input';
import Funcoes from '../../../Utils/functions';
import ApiService from '../../../Utils/services';
import './Dashboard.css';

import { Line } from 'react-chartjs-2';

export default function Dashboard() {
    const tiposChavePix = [
        { value: "1", text: "CPF" },
        { value: "2", text: "CNPJ" },
        { value: "3", text: "E-mail" },
        { value: "4", text: "Celular" },
        { value: "5", text: "Chave Aleatória" }
    ];

    const [redirect, setRedirect] = useState(false);
    const [path, setPath] = useState('/home');
    const [modal, setModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [alert, setAlert] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [alertType, setAlertType] = useState(2);
    const [today, setToday] = useState('');
    const [filter, setFilter] = useState(1);
    const [user, setUser] = useState({data: { produtos: [] } });
    const [tipoChavePix, setTipoChavePix] = useState('');
    const [chavePix, setChavePix] = useState('');
    const [pixTitular, setPixTitular] = useState('');
    const [valor, setValor] = useState('');
    const [senha, setSenha] = useState('');
    const [saldo, setSaldo] = useState({
        saldo_disponivel: '0,00',
        saldo_bloqueado: '0,00',
        total_contas: '0,00'
    });
    const [paymentMethodChart, setPaymentMethodChart] = useState({
        data: {
            labels: ['0h', '1h', '2h', '3h', '4h', '5h', '6h', '7h', '8h', '9h', '10h', '11h', '12h',
                '13h', '14h', '15h', '16h', '17h', '18h', '19h', '20h', '21h', '22h', '23h'],
            datasets: [
                {
                    label: "Boleto", fill: true, lineTension: 0.1, backgroundColor: 'rgba(255, 159, 64, 0.2)', borderColor: 'rgb(255, 159, 64)',
                    borderCapStyle: 'butt', borderDash: [5, 5], borderDashOffset: 0.0, borderJoinStyle: 'miter', pointBorderColor: 'rgb(255, 159, 64)',
                    pointBackgroundColor: 'rgb(255, 159, 64)', pointBorderWidth: 1, pointHoverRadius: 5, pointHoverBackgroundColor: 'rgb(255, 159, 64)',
                    pointHoverBorderColor: 'rgb(255, 159, 64)', pointHoverBorderWidth: 2, pointRadius: 3, pointHitRadius: 10,
                    data: []
                },
                {
                    label: 'Pix', fill: true, lineTension: 0.1, backgroundColor: 'rgba(75, 192, 192, 0.2)', borderColor: 'rgb(75, 192, 192)',
                    borderCapStyle: 'butt', borderDash: [5, 5], borderDashOffset: 0.0, borderJoinStyle: 'miter', pointBorderColor: 'rgb(75, 192, 192)',
                    pointBackgroundColor: 'rgb(75, 192, 192)', pointBorderWidth: 1, pointHoverRadius: 5, pointHoverBackgroundColor: 'rgb(75, 192, 192)',
                    pointHoverBorderColor: 'rgb(75, 192, 192)', pointHoverBorderWidth: 2, pointRadius: 3, pointHitRadius: 10,
                    data: []
                },
                {
                    label: 'Crédito', fill: true, lineTension: 0.1, backgroundColor: 'rgba(153, 102, 255, 0.2)', borderColor: 'rgb(153, 102, 255)',
                    borderCapStyle: 'butt', borderDash: [5, 5], borderDashOffset: 0.0, borderJoinStyle: 'miter', pointBorderColor: 'rgb(153, 102, 255)',
                    pointBackgroundColor: 'rgb(153, 102, 255)', pointBorderWidth: 1, pointHoverRadius: 5, pointHoverBackgroundColor: 'rgb(153, 102, 255)',
                    pointHoverBorderColor: 'rgb(153, 102, 255)', pointHoverBorderWidth: 2, pointRadius: 3, pointHitRadius: 10,
                    data: []
                },
            ]
        },
        options: {
            showScale: true, 
            showLines: true, 
            legend: { 
                display: true,
                position: 'top',
                labels: {
                    fontColor: '#333',
                    usePointStyle: true
                }
            },
            scales: {
                xAxes: [{ gridLines: { display: false } }],
                yAxes: [{
                    ticks: {
                        beginAtZero: true, min: 0, max: 1200,
                        callback: function (value) {
                            return 'R$ ' + (value < 1000 ? value : Funcoes.nFormatter(value));
                        }
                    }
                }]
            }
        }
    })

    useEffect(() => {
        setToday(Funcoes.geraDataExtenso());
        setLoading(true);
        const userData = JSON.parse(sessionStorage.getItem("userData"));
        setUser(userData);
        carregaSaldos(userData.token);
    }, []);

    const carregaSaldos = (token) => {
        setLoading(true);
        ApiService.get('dashboard/saldo', token)
            .then(result => {
                setSaldo({
                    saldo_disponivel: Funcoes.float2Preco(result.data.saldo_disponivel),
                    saldo_bloqueado: Funcoes.float2Preco(result.data.saldo_bloqueado),
                    total_contas: Funcoes.float2Preco(result.data.total_contas)
                });
                carregaRecebimentosPorMetodo(false, 1, token); 
            })
            .catch(err => {
                const result = ApiService.handleErros(err.response);
                if (result.status === "unauthorized") {
                    sessionStorage.removeItem('userData');
                    setPath('/');
                }
                setLoading(false);
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            })
    }

    const handleFilter = (filterId) => {
        carregaRecebimentosPorMetodo(false, filterId); 
    }

    const solicitarSaque = () => {
        if (valor === 0 || valor === '') {
            setAlertText('Informe o valor do saque');
            setAlert(true);
            return;
        }

        if (tipoChavePix === '') {
            setAlertText('Selecione o tipo da chave PIX');
            setAlert(true);
            return;
        }

        if (chavePix === '') {
            setAlertText('Informe a chave PIX');
            setAlert(true);
            return;
        }

        if (pixTitular === '') {
            setAlertText('Informe o nome do titular');
            setAlert(true);
            return;
        }

        if (senha === '') {
            setAlertText('Informe sua senha');
            setAlert(true);
            return;
        }

        setLoading(true);
        ApiService.post('transferencia/saquepix', {
            valor: valor,
            pix_tipo_chave: parseInt(tipoChavePix),
            pix_chave: chavePix,
            pix_titular: pixTitular,
            senha: senha
        }, user.token)
        .then(result => {
            setLoading(false);
            setModal(false);
            setAlertType(1);
            setAlertText('Saque solicitado com sucesso!');
            setTimeout(() => {
                setAlert(true);
            }, 300);
            carregaSaldos(user.token);
            limpaForm();
        })
        .catch(err => {
            setLoading(false);
            const result = ApiService.handleErros(err.response);
            setAlertText(result.response);
            setAlertType(2);
            setTimeout(() => {
                setAlert(true);
            }, 300);
        });
    }

    const limpaForm = () => {
        setValor('');
        setTipoChavePix('');
        setChavePix('');
        setPixTitular('');
        setSenha('');
    }

    const formatarChavePix = (valor) => {
        if (!valor) return '';

        switch (tipoChavePix) {
            case '1': // CPF
                return valor.replace(/\D/g, '')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d{1,2})$/, '$1-$2')
                    .substr(0, 14);
            case '2': // CNPJ
                return valor.replace(/\D/g, '')
                    .replace(/(\d{2})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1.$2')
                    .replace(/(\d{3})(\d)/, '$1/$2')
                    .replace(/(\d{4})(\d)/, '$1-$2')
                    .substr(0, 18);
            case '4': // Celular
                return valor.replace(/\D/g, '')
                    .replace(/(\d{2})(\d)/, '($1) $2')
                    .replace(/(\d{5})(\d)/, '$1-$2')
                    .substr(0, 15);
            default:
                return valor;
        }
    }

    const handleChavePixChange = (e) => {
        const valorFormatado = formatarChavePix(e.target.value);
        setChavePix(valorFormatado);
    }

    const formatarValor = (valor) => {
        if (!valor) return '';
        
        // Remove tudo que não é número
        valor = valor.replace(/\D/g, '');
        
        // Converte para número e divide por 100 para ter os centavos
        const numero = parseFloat(valor) / 100;
        
        // Formata com 2 casas decimais e troca ponto por vírgula
        return numero.toLocaleString('pt-BR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });
    }

    const handleValorChange = (e) => {
        const valorFormatado = formatarValor(e.target.value);
        setValor(valorFormatado);
    }

    const handleTipoChavePixChange = (e) => {
        setTipoChavePix(e.target.value);
        setChavePix(''); // Limpa a chave quando troca o tipo
    }

    const carregaRecebimentosPorMetodo = (carrega, filtro, token) => {
        if(carrega){
            setLoading(true);
        }

        if(token === undefined){
            token = user.token;
        }

        ApiService.get('dashboard/recebimentos-por-metodo?periodo=' + filtro, token)
            .then(result => {
                const res = result.data;
             
                
                var labels = [];
                var boleto = [];
                var pix = [];
                var credito = [];
                var maxValue = 0;

                // Verifica se os dados da API são válidos
                if (res.boleto && res.boleto.length > 0) {
                    // Usar todos os intervalos como labels
                    for (var i = 0; i < res.boleto.length; i++) {
                        labels.push(res.boleto[i].intervalo);
                        // Armazenar os valores numéricos para o gráfico
                        boleto.push(parseFloat(res.boleto[i].valor));
                        pix.push(parseFloat(res.pix[i].valor));
                        credito.push(parseFloat(res.credito[i].valor));
                        
                        // Encontrar o valor máximo para a escala do gráfico
                        maxValue = Math.max(maxValue, parseFloat(res.boleto[i].valor), parseFloat(res.pix[i].valor), parseFloat(res.credito[i].valor));
                    }
                } else {
                    console.error("Dados vazios ou inválidos recebidos da API");
                    
                    // Configuração padrão se não houver dados
                    if (filtro === 1 || filtro === 2) {
                        // Para hoje/ontem, usar horas
                        for (var i = 0; i < 24; i++) {
                            labels.push(i + 'h');
                            boleto.push(0);
                            pix.push(0);
                            credito.push(0);
                        }
                    } else {
                        // Para períodos maiores, usar dias genéricos
                        for (var i = 1; i <= 7; i++) {
                            labels.push('Dia ' + i);
                            boleto.push(0);
                            pix.push(0);
                            credito.push(0);
                        }
                    }
                }

         

                // Atualizar o estado do gráfico com os novos dados
                var newData = {
                    labels: labels,
                    datasets: [
                        {
                            label: "Boleto", 
                            fill: true, 
                            lineTension: 0.1, 
                            backgroundColor: 'rgba(255, 159, 64, 0.2)', 
                            borderColor: 'rgb(255, 159, 64)',
                            borderCapStyle: 'butt', 
                            borderDash: [5, 5], 
                            borderDashOffset: 0.0, 
                            borderJoinStyle: 'miter', 
                            pointBorderColor: 'rgb(255, 159, 64)',
                            pointBackgroundColor: 'rgb(255, 159, 64)', 
                            pointBorderWidth: 1, 
                            pointHoverRadius: 5, 
                            pointHoverBackgroundColor: 'rgb(255, 159, 64)',
                            pointHoverBorderColor: 'rgb(255, 159, 64)', 
                            pointHoverBorderWidth: 2, 
                            pointRadius: 3, 
                            pointHitRadius: 10,
                            data: boleto
                        },
                        {
                            label: 'Pix', 
                            fill: true, 
                            lineTension: 0.1, 
                            backgroundColor: 'rgba(75, 192, 192, 0.2)', 
                            borderColor: 'rgb(75, 192, 192)',
                            borderCapStyle: 'butt', 
                            borderDash: [5, 5], 
                            borderDashOffset: 0.0, 
                            borderJoinStyle: 'miter', 
                            pointBorderColor: 'rgb(75, 192, 192)',
                            pointBackgroundColor: 'rgb(75, 192, 192)', 
                            pointBorderWidth: 1, 
                            pointHoverRadius: 5, 
                            pointHoverBackgroundColor: 'rgb(75, 192, 192)',
                            pointHoverBorderColor: 'rgb(75, 192, 192)', 
                            pointHoverBorderWidth: 2, 
                            pointRadius: 3, 
                            pointHitRadius: 10,
                            data: pix
                        },
                        {
                            label: 'Crédito', 
                            fill: true, 
                            lineTension: 0.1, 
                            backgroundColor: 'rgba(153, 102, 255, 0.2)', 
                            borderColor: 'rgb(153, 102, 255)',
                            borderCapStyle: 'butt', 
                            borderDash: [5, 5], 
                            borderDashOffset: 0.0, 
                            borderJoinStyle: 'miter', 
                            pointBorderColor: 'rgb(153, 102, 255)',
                            pointBackgroundColor: 'rgb(153, 102, 255)', 
                            pointBorderWidth: 1, 
                            pointHoverRadius: 5, 
                            pointHoverBackgroundColor: 'rgb(153, 102, 255)',
                            pointHoverBorderColor: 'rgb(153, 102, 255)', 
                            pointHoverBorderWidth: 2, 
                            pointRadius: 3, 
                            pointHitRadius: 10,
                            data: credito
                        }
                    ]
                };
                
                var newOptions = {
                    showScale: true, 
                    showLines: true, 
                    legend: { 
                        display: true,
                        position: 'top',
                        labels: {
                            fontColor: '#333',
                            usePointStyle: true
                        }
                    },
                    tooltips: {
                        callbacks: {
                            label: function(tooltipItem, data) {
                                var label = data.datasets[tooltipItem.datasetIndex].label || '';
                                var value = tooltipItem.yLabel;
                                if (value !== null) {
                                    value = 'R$ ' + value.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    });
                                }
                                return label + ': ' + value;
                            }
                        }
                    },
                    scales: {
                        xAxes: [{ gridLines: { display: false } }],
                        yAxes: [{
                            ticks: {
                                beginAtZero: true, 
                                min: 0, 
                                max: maxValue * 1.2 > 0 ? maxValue * 1.2 : 1000,
                                callback: function (value) {
                                    return 'R$ ' + value.toLocaleString('pt-BR', {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2
                                    });
                                }
                            }
                        }]
                    }
                };

                setPaymentMethodChart({ data: newData, options: newOptions });
                setFilter(filtro);
                setLoading(false);
            })
            .catch(err => {
                console.error("Erro ao buscar dados:", err);
                const result = ApiService.handleErros(err.response);
                setLoading(false);
                if (result.status === "unauthorized") {
                    sessionStorage.removeItem('userData');
                    setPath('/');
                }
                setAlertText(result.response);
                setTimeout(() => {
                    setAlert(true);
                }, 300);
            });
    }

    return (
        <>
            <Redirect redirect={redirect} path={path} />
            <Loading show={loading} />
            <Alert show={alert} texto={alertText} subText={alertType === 1 ? '*Solicitações realizadas após as 22h poderão ser processadas no próximo dia útil. * Solicitações realizadas antes deste horário serão realizadas em até 1 hora.' : ''} tipo={alertType} action={() => { setAlert(false); setRedirect(path ? true : false) }} />
            <Modal show={modal} footer={<>
                        <button 
                            className="btn secondary" 
                            onClick={() => setModal(false)}
                        >
                            Cancelar
                        </button>
                        <button 
                            className="btn primary"
                            onClick={solicitarSaque}
                        >
                            Confirmar
                        </button>
                </>} onClose={() => setModal(false)}>
            
                <div className="header">
                    <h2>Solicitar Saque</h2>
                </div>

                <div className="form-group">
                    <Input
                        label="Valor"
                        type="money"
                        value={valor}
                        onChangeEvent={(e, masked, floatValue) => setValor(floatValue)}
                        autoComplete="off"
                        inputMode="decimal"
                        placeholder="0,00"
                    />
                    <p className="saldo-disponivel-label">Saldo disponível: R$ {saldo.saldo_disponivel}</p>
                </div>

                <div className="form-group">
                    <label>Tipo de Chave PIX</label>
                    <select 
                        value={tipoChavePix}
                        onChange={handleTipoChavePixChange}
                    >
                        <option value="">Selecione</option>
                        {tiposChavePix.map(tipo => (
                            <option key={tipo.value} value={tipo.value}>
                                {tipo.text}
                            </option>
                        ))}
                    </select>
                </div>

                <div className="form-group">
                    <Input
                        label="Chave PIX"
                        type="text"
                        value={chavePix}
                        onChange={handleChavePixChange}
                        onPaste={handleChavePixChange}
                        onBlur={handleChavePixChange}
                        placeholder={tipoChavePix === '3' ? 'email@exemplo.com' : 
                                    tipoChavePix === '4' ? '(99) 99999-9999' : 
                                    tipoChavePix === '1' ? '999.999.999-99' :
                                    tipoChavePix === '2' ? '99.999.999/9999-99' : 
                                    'Digite sua chave PIX'}
                    />
                </div>

                <div className="form-group">
                    <Input
                        label="Nome do Titular"
                        type="text"
                        value={pixTitular}
                        onChange={(e) => setPixTitular(e.target.value)}
                        placeholder="Digite o nome do titular"
                        maxLength={100}
                    />
                </div>

                <div className="form-group">
                    <Input
                        label="Senha"
                        type="password"
                        value={senha}
                        onChange={(e) => setSenha(e.target.value)}
                        placeholder="Digite sua senha"
                    />
                </div>
            </Modal>
            <SideMenu menuAtivo={1} />

            <div className="body">
                <Header />

                <div className="dashboard mgDefault">
                    <div className="headerBtn">
                        <div>
                            <h1>dashboard</h1>
                            <p className="descricao">{today}</p>
                        </div>
                        <button className="btn" onClick={() => setModal(true)}>Solicitar Saque</button>
                    </div>

                    <div className="rowCenter">
                        <div className="panel" style={{ width: '50%' }}>
                            <p>Saldo Disponível</p>
                            <h3>R$ {saldo.saldo_disponivel}</h3>
                        </div>
                        <div className="panel" style={{ width: '50%' }}>
                            <p>À Liberar/Bloqueado</p>
                            <h3 className="cinza">R$ {saldo.saldo_bloqueado}</h3>
                        </div>
                    </div>

                    <h2 className="titlePanel mobile-hidden">Recebimentos por Método de Pagamento</h2>
                    <div className="panel mobile-hidden">
                        <div className="header">
                            <div className="filtros">
                                <button className={filter === 1 ? "btn active" : "btn"}
                                    onClick={() => handleFilter(1)}>hoje</button>
                                <button className={filter === 2 ? "btn active" : "btn"}
                                    onClick={() => handleFilter(2)}>ontem</button>
                                <button className={filter === 3 ? "btn active" : "btn"}
                                    onClick={() => handleFilter(3)}>últimos 7 dias</button>
                                <button className={filter === 4 ? "btn active" : "btn"}
                                    onClick={() => handleFilter(4)}>esse mês</button>
                            </div>
                            
                        </div>
                        <Line data={paymentMethodChart.data} options={paymentMethodChart.options} height={80} />
                    </div>
                </div>
            </div>
        </>
    )
}
